import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule, FormlyBootstrapModule } from 'ng-formly';


import { AuthGuard, SharedModule } from '../shared';
import { reportService } from './reports.service';
//import { FormlyDatePicker } from '../Lead/datePicker';

import { ReportComponent } from './reports.component';
import { MyDatePickerModule } from 'mydatepicker';
//import { OrderrByPipe } from '../shared/pipes/orderby.pipe';

const ReportRouting: ModuleWithProviders = RouterModule.forChild([
  {
    path: 'reports',
    component: ReportComponent,
    canActivate: [AuthGuard]
  }
]);

@NgModule({
  imports: [
    SharedModule,
    ReportRouting,
    NgbModule.forRoot(),
    MyDatePickerModule,
    FormlyModule.forRoot({
     
    }),
    FormlyBootstrapModule,
    FormsModule,
    ReactiveFormsModule,
   // OrderrByPipe
  ],
  declarations: [
    ReportComponent
       // OrderrByPipe
  ],
  providers: [reportService]
})
export class ReportModule { }



// WEBPACK FOOTER //
// ./src/app/Reports/reports.module.ts